module.exports = __webpack_public_path__ + "static/media/llysine1.63e77669.pdf";